import React from 'react';
import LogInOrRegister from '~/shared/pages/LogInOrRegisterPage/LogInOrRegister';

interface Props {
  navigateToNextPage?: (...args: unknown[]) => unknown;
}

const LogInOrRegisterPage = ({ navigateToNextPage }: Props) => {
  return <LogInOrRegister handleClick={navigateToNextPage} />;
};

export default LogInOrRegisterPage;
